import React from 'react';
import { TrendingUp, Clock3, HandCoins } from 'lucide-react';

export const RevenueImpact = () => (
    <section style={{ padding: '120px 0', borderTop: '1px solid var(--border-subtle)', background: 'var(--bg-primary)', position: 'relative' }}>
        <div className="container">
            <div style={{ textAlign: 'center', marginBottom: '80px', maxWidth: '800px', margin: '0 auto 80px auto' }}>
                <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', letterSpacing: '-0.02em', marginBottom: '24px' }}>
                    Increase Table Turnover. <br />
                    <span style={{ color: 'var(--accent-primary)' }}>Increase Daily Revenue.</span>
                </h2>
                <p style={{ color: 'var(--text-tertiary)', fontSize: '1.25rem', lineHeight: 1.6 }}>
                    Faster service = faster table clearance = more customers per day = more money.
                </p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px' }}>
                <div className="glass-panel" style={{ padding: '40px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'var(--bg-secondary)', border: '1px solid var(--border-focus)' }}>
                    <div style={{ background: 'rgba(59, 130, 246, 0.1)', padding: '16px', borderRadius: '50%', marginBottom: '24px' }}>
                        <TrendingUp size={32} color="var(--accent-primary)" />
                    </div>
                    <div style={{ fontSize: '2.5rem', fontWeight: 800, fontFamily: 'var(--font-display)', color: 'var(--text-primary)', marginBottom: '16px' }}>Faster Turnover</div>
                    <p style={{ color: 'var(--text-secondary)' }}>Reduce idle wait times between ordering, eating, and paying.</p>
                </div>

                <div className="glass-panel" style={{ padding: '40px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'var(--bg-secondary)', border: '1px solid var(--border-focus)' }}>
                    <div style={{ background: 'rgba(16, 185, 129, 0.1)', padding: '16px', borderRadius: '50%', marginBottom: '24px' }}>
                        <Clock3 size={32} color="#10B981" />
                    </div>
                    <div style={{ fontSize: '2.5rem', fontWeight: 800, fontFamily: 'var(--font-display)', color: 'var(--text-primary)', marginBottom: '16px' }}>More Customers</div>
                    <p style={{ color: 'var(--text-secondary)' }}>Serve more guests per shift with optimized operations.</p>
                </div>

                <div className="glass-panel" style={{ padding: '40px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'var(--bg-secondary)', border: '1px solid var(--border-focus)' }}>
                    <div style={{ background: 'rgba(139, 92, 246, 0.1)', padding: '16px', borderRadius: '50%', marginBottom: '24px' }}>
                        <HandCoins size={32} color="var(--accent-secondary)" />
                    </div>
                    <div style={{ fontSize: '2.5rem', fontWeight: 800, fontFamily: 'var(--font-display)', color: 'var(--text-primary)', marginBottom: '16px' }}>More Profit</div>
                    <p style={{ color: 'var(--text-secondary)' }}>Boost daily revenue seamlessly and securely through digital payments.</p>
                </div>
            </div>
        </div>
    </section>
);
